/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { DriveInRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { DriveInResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DriveInApi - axios parameter creator
 * @export
 */
export const DriveInApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit the store drive in details
         * @summary Submit the store drive in details
         * @param {string} storeId The store identifier.
         * @param {DriveInRequest} driveInRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driveIn: async (storeId: string, driveInRequest: DriveInRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('driveIn', 'storeId', storeId)
            // verify required parameter 'driveInRequest' is not null or undefined
            assertParamExists('driveIn', 'driveInRequest', driveInRequest)
            const localVarPath = `/store/{storeId}/xorder/requestCreneauDrive`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driveInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriveInApi - functional programming interface
 * @export
 */
export const DriveInApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriveInApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit the store drive in details
         * @summary Submit the store drive in details
         * @param {string} storeId The store identifier.
         * @param {DriveInRequest} driveInRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driveIn(storeId: string, driveInRequest: DriveInRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driveIn(storeId, driveInRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriveInApi - factory interface
 * @export
 */
export const DriveInApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriveInApiFp(configuration)
    return {
        /**
         * Submit the store drive in details
         * @summary Submit the store drive in details
         * @param {string} storeId The store identifier.
         * @param {DriveInRequest} driveInRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driveIn(storeId: string, driveInRequest: DriveInRequest, options?: any): AxiosPromise<DriveInResponse> {
            return localVarFp.driveIn(storeId, driveInRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriveInApi - object-oriented interface
 * @export
 * @class DriveInApi
 * @extends {BaseAPI}
 */
export class DriveInApi extends BaseAPI {
    /**
     * Submit the store drive in details
     * @summary Submit the store drive in details
     * @param {string} storeId The store identifier.
     * @param {DriveInRequest} driveInRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveInApi
     */
    public driveIn(storeId: string, driveInRequest: DriveInRequest, options?: any) {
        return DriveInApiFp(this.configuration).driveIn(storeId, driveInRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
